import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/home/home';
import About from './pages/about/about';
import Services from './pages/services/services';
import Contact from './pages/contact/contact';
import Countertops from './pages/services/countertops';
import Kitchens from './pages/services/kitchens';
import Bathrooms from './pages/services/bathrooms';
import Fixtures from './pages/services/fixtures';
import Navbar from './components/navbar/navbar';
import Footer from './components/footer/footer';
import ScrollToTop from "./helpers/scroll-to-top";

import AnalyticsTracker from "./helpers/google-analytics/analyticsTracker";

import useCleanTrackingParams from "./helpers/useCleanTrackingParams";

import './styles/globalStyles.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AnalyticsTracker />
      <CleanTrackingParamsWrapper /> 
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/countertops" element={<Countertops />} />
        <Route path="/services/kitchens" element={<Kitchens />} />
        <Route path="/services/bathrooms" element={<Bathrooms />} />
        <Route path="/services/fixtures" element={<Fixtures />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </Router>
  );
}

function CleanTrackingParamsWrapper() {
  useCleanTrackingParams();
  return null; // No UI output, just side-effect
}

export default App;